
const isNews=false;
const loadProduct=false;
  export default
  {
    isNews, //是否已加载最新的字典
    loadProduct
  }



// WEBPACK FOOTER //
// ./src/vue/Global.vue